import React from "react";
import "./Applitan.scss";
import Qrcode from "../../images/qrcode_applistore.svg";
import MobileIcon from "../../images/mobile-screen-button-solid.svg";
import AnimatedPage from "../AnimatedPage";
import ApplicationTan from "../../videos/application_tan.mp4";
import ApplicationTanImg from "../../images/application_tan.jpg";

const Applitan = () => {
  return (
    <AnimatedPage>
      <div className="applitan__ctn">
        <div className="col col1">
          <h1>Télécharger l'application</h1>
          <img className="qrcode" src={Qrcode} alt="QR Code Appli Tan" />
          <div className="icon-caption">
            <img className="mobile-icon" src={MobileIcon} alt="Icon Mobile" />
            <p class="scan">Scannez-moi</p>
          </div>
        </div>
        <div className="separator"></div>
        <div className="col col2">
          <h1>Guide d'utilisation mTicket</h1>
          <video controls width="500" height="500" poster={ApplicationTanImg}>
            <source src={ApplicationTan} type="video/webm" />
          </video>
          <p className="caption">Appuyez sur la vidéo pour regarder le guide</p>
        </div>
      </div>
    </AnimatedPage>
  );
};

export default Applitan;
